import { useParams, useNavigate } from 'react-router-dom';
import { Card, Spin } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import PropertyAmenityForm from '../components/PropertyAmenityForm';
import { usePropertyAmenityDetails } from '../hooks/usePropertyAmenityQueries';
import { useUpdatePropertyAmenity } from '../hooks/usePropertyAmenityMutations';

export default function PropertyAmenityEditPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data, isLoading: loadingDetails } = usePropertyAmenityDetails(id);
  const mutation = useUpdatePropertyAmenity();
  const handleSubmit = (formData: any) => { (mutation.mutate as any)({ id, data: formData }, { onSuccess: () => navigate('/property-amenities') }); };
  if (loadingDetails) return <Spin style={{ display: 'block', margin: '80px auto' }} />;
  return (
    <div>
      <PageHeader back title={t('propertyAmenities.editTitle')} subtitle={`${t('common.editing')}: ${data?.nameEn || ''}`} />
      <Card><PropertyAmenityForm initialData={data} onSubmit={handleSubmit} isLoading={mutation.isPending} /></Card>
    </div>
  );
}
